module.exports = __webpack_public_path__ + "static/img/step4.f0f1b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/businessFlow/step4.png
// module id = FYtc
// module chunks = 1